import { useState } from 'react';
import useVendorsForModal from './useVendorsForModal';

const useVendorField = (open, onVendorSelected) => {
  const { vendors, setVendors, vendorsLoading } = useVendorsForModal(open);
  const [addVendorOpen, setAddVendorOpen] = useState(false);

  const handleVendorCreated = (vendor) => {
    setVendors((prev) => [...prev, vendor]);
    onVendorSelected?.(String(vendor.id));
    setAddVendorOpen(false);
  };

  return {
    vendors,
    setVendors,
    vendorsLoading,
    addVendorOpen,
    setAddVendorOpen,
    onAddVendor: () => setAddVendorOpen(true),
    handleVendorCreated
  };
};

export default useVendorField;
